import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import TermsPage from './pages/Terms.js';
import PrivacyPage from './pages/Privacy.js';
import ContactPage from './pages/Contact.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
         
      <Route path="/terms" element={<TermsPage />} />
         
      <Route path="/privacy" element={<PrivacyPage />} />

      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

export default App;
